import { useAppContext } from '../context/AppContext';
import Seo from '../components/Seo';
import assetPath from '../utils/assetPath';

const copy = {
  en: {
    title: 'Merch In Preparation',
    body: 'We are finalizing patches, jerseys, and utility items. Enable Instagram notifications so you do not miss the launch.',
    cta: 'Follow @salty.airsoft',
  },
  fr: {
    title: 'Merch en préparation',
    body: 'Nous finalisons les patchs, jerseys et accessoires utilitaires. Activez les notifications Instagram pour ne pas rater la sortie.',
    cta: 'Suivre @salty.airsoft',
  },
};

const Merch = () => {
  const { language } = useAppContext();
  const t = copy[language];

  return (
    <>
      <Seo title="Merch" description={t.body} image={assetPath('/assets/logo-salty.png')} url="https://salty-squad.fr/merch" />
      <section className="coming-soon">
        <p className="unit">{language === 'fr' ? 'Bientôt' : 'Soon'}</p>
        <h1>{t.title}</h1>
        <p>{t.body}</p>
        <a className="btn ghost" href="https://www.instagram.com/salty.airsoft/" target="_blank" rel="noreferrer">
          {t.cta}
        </a>
      </section>
    </>
  );
};

export default Merch;
